import React, { useEffect, useState } from "react";
import * as S from './styles.js';
import api from "../../../services/api.js";
import GraphicCircle from "./GraphicCircle.js";
import { TaglineP } from "../../../styles/stylesTypography.js";
import { theme } from "../../../styles/theme.js";

export const compendioG = "@compendioG";

const userData = JSON.parse(localStorage.getItem("@userinfo"));

const CircleDataTotvs = ({ ...props }) => {
    const [responsaveis, setResponsaveis] = useState([]);
    const [selectedResponsavel, setSelectedResponsavel] = useState(null);
    const [arts, setArts] = useState(0);
    const [receitas, setReceitas] = useState(0);
    const [type, setType] = useState("");
    const [numeroArt, setNumeroArt] = useState(0);
    const [isLoading, setIsloading] = useState(true);
    const [credits, setCredits] = useState(0);
    const [maxQuantity, setMaxQuantity] = useState(0);

    const getRecipes = async () => {
        try {
            const response = await api.get(`/home/receitas-art`);
            const responseSave = response.data.data;

            const formattedData = responseSave.map((item) => ({
                responsavel: item.responsavel,
                receitas_restantes: item.receitas_restantes,
                arts_disponiveis: item.arts_disponiveis,
                tipo: item.tipo,
                numero_art: item.numero_art
            }));

            setResponsaveis(formattedData);

            if (formattedData.length > 0) {
                setSelectedResponsavel(formattedData[0].responsavel);
                setReceitas(formattedData[0].receitas_restantes);
                setArts(formattedData[0].arts_disponiveis);
                setType(formattedData[0].tipo);
                setIsloading(false);
                setNumeroArt(formattedData[0].numero_art)
            }

            setTimeout(() => {
                if (formattedData.length === 0) {
                    setIsloading(false);
                    setSelectedResponsavel(null);
                }
            }, 3000);

        } catch (error) {
            console.error("Erro ao buscar receitas:", error);
            setIsloading(false);
        }
    };

    useEffect(() => {
        getRecipes();
    }, []);

    const handleSelectChange = (event) => {
        const selected = event.target.value;
        setSelectedResponsavel(selected);

        const found = responsaveis.find((item) => item.responsavel === selected);
        if (found) {
            setReceitas(found.receitas_restantes);
            setArts(found.arts_disponiveis);
            setType(found.tipo);
            setNumeroArt(found.numero_art)
        }
    };

    const getInitials = (name) => {
        if (!name) return '';

        const cleanedName = name.replace(/\([^)]*\)/g, '').trim();

        const nameParts = cleanedName
            .split(' ')
            .filter(part => part.toLowerCase() !== '');

        if (nameParts.length >= 2) {
            return nameParts
                .slice(0, 2)
                .map(part => part.charAt(0).toUpperCase())
                .join('');
        } else if (nameParts.length === 1) {
            return nameParts[0].substring(0, 2).toUpperCase();
        }

        return '';
    };

    const getSaldo = async () => {
        try {
            const response = await api.get(`receitas/saldo`);
            const saldoData = response.data.data;

            setCredits(saldoData.saldo)

        } catch (error) {
            console.error("Erro ao buscar saldo:", error);
        }
    }

    const getMaxQuantity = async () => {
        try {
            const response = await api.get(`planos/qtd-receitas`)

            setMaxQuantity(response.data.data.limite_receitas);
        } catch (error) {
            console.error("Erro ao buscar saldo:", error); 
        }
    }

    useEffect(() => {
        getSaldo();
        getMaxQuantity();
    }, [])

    return (
        <S.Container className="circleData">
            <S.Wrapper>
                <S.ProfileCircle>
                    <S.Profile>
                        <select name="select-productor" id="select-productor" onChange={handleSelectChange}>
                            {isLoading ? (
                                <option>Carregando dados...</option>
                            ) : (
                                responsaveis.length > 0 ? (
                                    responsaveis.map((data, index) => (
                                        <option key={index} value={data.responsavel}>
                                            {data.responsavel}
                                        </option>
                                    ))
                                ) : (
                                    <option>Nenhum responsável</option>
                                )
                            )}
                        </select>
                    </S.Profile>

                    {/* Adicionando a div circular com as iniciais do responsável */}
                    {selectedResponsavel && (
                        <S.InitialsCircle>
                            {getInitials(selectedResponsavel)}
                        </S.InitialsCircle>
                    )}
                </S.ProfileCircle>

                <S.CirclesContainer>
                    <S.CircleData>
                        <GraphicCircle value={receitas} />

                        <TaglineP color={theme.colors.gray.Cinza_2}>
                            {type ? type : "Receitas"} <br /> RESTANTES
                        </TaglineP>
                    </S.CircleData>
                    {(
                        userData.contrato.agro_plan_config.nome_plano === "PLANO BASIC" ||
                        userData.contrato.agro_plan_config.nome_plano === "PLANO PRÉ-PAGO"
                    ) && (
                            <S.CircleTRT>
                                <GraphicCircle value={credits} maxQuantity={maxQuantity} isCredit />
                                <TaglineP color={theme.colors.gray.Cinza_2}>
                                    Créditos <br /> disponíveis
                                </TaglineP>
                            </S.CircleTRT>
                        )}
                </S.CirclesContainer>
            </S.Wrapper>
        </S.Container>
    );
};

export default CircleDataTotvs;
